import React from 'react';
import cx from 'classnames';
import { branch, renderComponent } from 'recompose';

import styles from './styles.css';

export type Props = {
  className?: string;
  size?: 'small' | 'half' | 'full';
  empty?: boolean;
  top?: number;
  bottom?: number;
  children?: any;
};

export const Divider = ({
  className,
  top: marginTop,
  bottom: marginBottom,
  size,
  empty,
  children,
}: Props) =>
  React.createElement(
    !!children ? 'div' : 'hr',
    {
      className: cx(
        styles.root,
        styles[size],
        empty && styles.empty,
        className
      ),
      style: { marginTop, marginBottom },
    },
    children && <span className={styles.child}>{children}</span>
  );
